const init = () => {
    const HAMBURGER_SELECTOR = '.header__toggle-menu';
    const MENU_MOBILE_SELECTOR = '.menu-mobile';

    const HAS_CHILDREN_SELECTOR = '.menu-mobile .has-children';

    const $hamburger = $(HAMBURGER_SELECTOR);
    const $menu = $(MENU_MOBILE_SELECTOR);

    const $hasChildren = $(HAS_CHILDREN_SELECTOR);

    $hamburger.on('click', function(){
        const $this = $(this);
        $this.find('.hamburger').toggleClass('is-active');
        $('html').toggleClass('overflow-hidden');
        $menu.toggleClass('is-visible');
    });

    $hasChildren.on('click', function(){
        const $this = $(this);
        $this.toggleClass('expanded')
        const submenu = $this.find('.sub-menu');
        submenu.hasClass('is-visible') ? submenu.removeClass('is-visible') : submenu.addClass('is-visible');

    });

}

export default {
    init
}